module.exports = __webpack_public_path__ + "static/media/55_000020.99f52ebf.jpg";